"use client"

import { Plus, LayoutGrid, HelpCircle, Bell, ChevronRight, Share2Icon, ShareIcon, Activity, ActivitySquare, List } from "lucide-react"
import { Button } from "@/components/ui/Button"
import type { GetContractResponseContent } from "src/types/contract.types"
import { useSidebarContext } from "../contexts/activity-sidebar-context"

interface TopNavigationProps {
  contract: GetContractResponseContent | null
}

export function TopNavigation({ contract }: TopNavigationProps) {
  const { sidebarOpen, toggleSidebar } = useSidebarContext()
  return (
    <div className="sticky top-0 z-50 border-b bg-background/95 backdrop-blur supports-backdrop-filter:bg-background/60">
      <div className="flex h-14 items-center gap-4 px-6">
        <div className="flex items-center gap-1 text-sm text-muted-foreground">
          <p>Contract Editor</p>
          <ChevronRight className="size-4" />
          <p className="text-foreground font-medium rounded-full px-3 py-1 bg-muted">{contract?.name}</p>
        </div>
        <div className="flex-1" />
        <div className="flex items-center gap-2">
          <Button variant="default" size="sm" className="bg-primary text-primary-foreground pr-3 pl-2" rounded="full">
            <ShareIcon className="size-3.5" />
            Share
          </Button>
          <Button variant="secondary" onClick={toggleSidebar}>
            <List className="size-3" />
            <span className="">{ sidebarOpen ? "Close Activity" : "Open Activity" }</span>
          </Button>
          <Button variant="ghost" size="icon">
            <LayoutGrid className="size-5" />
          </Button>
        </div>
      </div>
    </div>
  )
}
